




































































































































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import {FraudCase} from "@/model/fraud-case";
import {fraudCaseService} from "@/services/fraud-case";
import FraudCaseDetails from "@/components/FraudCaseDetails.vue";
import {CriteriaType} from "@/model/filter-criteria";
@Component({
  components: {FraudCaseDetails}
})
export default class ExpandFraudCase extends Vue {

  @Prop()
  dialog!: boolean

  @Prop()
  fraudCase!: FraudCase

  @Prop()
  complete!: boolean

  completeFraudCase: FraudCase | null = null

  loading = false;

  criterias: CriteriaType[] = [
    CriteriaType.MSISDN,
    CriteriaType.CREDIT_CARD_TOKEN,
    CriteriaType.USER_ID,
    CriteriaType.PAYPAL_PAYER_ID
  ]
  get: CriteriaType = CriteriaType.MSISDN
  relatedTo: CriteriaType = CriteriaType.CREDIT_CARD_TOKEN
  orderUsd = 0
  dateModal = false
  startDate = '2020-01-01'
  search: any = {
    'items': [],
    'transactions': []
  }
  colors: any = {}

  expanded = false

  whyAdded = ''
  whyPardoned = ''
  pardoned = false

  @Watch('get', { deep: true})
  @Watch('relatedTo', { deep: true})
  @Watch('orderUsd', { deep: true})
  @Watch('startDate', { deep: true})
  onSearchCriteriaChange() {
    this.search = {
      'items': [],
      'transactions': []
    }
    this.whyAdded = ''
    this.whyPardoned = ''
    this.pardoned = false
    this.expanded = false
  }

  async doSearch() {
    this.search = await fraudCaseService.getExpand(this.fraudCase.id,this.get,this.relatedTo,this.startDate,this.orderUsd)
    const msisdns = [...new Set(this.search.transactions?.map((t: any) => t.msisdn))]

    msisdns.forEach((number: any,index) => {
      this.colors[number] = this.selectColor(index)
    })

    this.expanded = true
  }

  selectColor(number: number) {
    const hue = number * 137.508; // use golden angle approximation
    return `hsl(${hue},50%,75%)`;
  }

  async doPost() {
    await fraudCaseService.postExpand(
      this.fraudCase.id,
      this.get,
      this.relatedTo,
      this.startDate,
      this.orderUsd,
      this.whyAdded,
      this.whyPardoned,
      this.pardoned)
    console.log('')
  }


  @Watch('fraudCase',{
    deep: true
  })
  async onFraudCaseChange() {
    this.loading = true
    this.completeFraudCase = null
    if(this.complete) {
      this.completeFraudCase = this.fraudCase;
    } else {
      this.completeFraudCase = await fraudCaseService.getFraudCaseById(this.fraudCase.id);
    }
    this.search = {
      'items': [],
      'transactions': []
    }
    this.startDate = '2020-01-01'
    this.loading = false
    this.orderUsd = 0
    this.whyAdded = ''
    this.whyPardoned = ''
    this.pardoned = false
    this.expanded = false
  }

  doCancel() {
    this.$emit('closeDialog',true)
  }
}
